export const NOTIFICATION_TYPE = {
  ANNOUNCEMENT_GENERAL: 'ANNOUNCEMENT_GENERAL',
  ANNOUNCEMENT_COURSE: 'ANNOUNCEMENT_COURSE',
  ANNOUNCEMENT_TASK: 'ANNOUNCEMENT_TASK',
  COURSE: 'COURSE',
  TASK: 'TASK',
  USER_ORGANIZATION_JOIN: 'USER_ORGANIZATION_JOIN'
};

export const ANNOUNCEMENT_TYPE = {
  GENERAL: 'General',
  COURSE: 'Course',
  TASK: 'Task'
};

export const ANNOUNCEMENT_TYPE_TO_NOTIFICATION_TYPE = {
  [ANNOUNCEMENT_TYPE.GENERAL]: NOTIFICATION_TYPE.ANNOUNCEMENT_GENERAL,
  [ANNOUNCEMENT_TYPE.COURSE]: NOTIFICATION_TYPE.ANNOUNCEMENT_COURSE,
  [ANNOUNCEMENT_TYPE.TASK]: NOTIFICATION_TYPE.ANNOUNCEMENT_TASK
};
